import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBars } from "@fortawesome/free-solid-svg-icons";
import { Facebook, Instagram, Twitter } from "lucide-react";
import Bike2 from "../../../assets/Images/bike2.png";
import Nav from "../Nav";
import Footer from "../Footer";
import Slider from "react-slick";
import Seo from "../../Seo/Seo";
import { useSeoMeta } from "../../Seo/useSeoMeta";
import { SITE_NAME } from "../../Seo/seoConfig";
import wlogo from "../../../assets/Images/TCL_logo (1).png";
import wha from "../../../assets/Images/wha.jpg";
import "./BikePackage.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const HotelPackage = () => {
  const centralizedSeo = useSeoMeta();
  const [bikePackages, setBikePackages] = useState([]);
  const [hotelPackages, setHotelPackages] = useState([]);
  const [isToggled, setIsToggled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}AllPackages`);
        const result = await response.json();
        const allPackages = result?.data || [];

        const filteredBikes = allPackages.filter(pkg =>
          pkg?.category?.name?.includes("Hotels")
        );
        setBikePackages(filteredBikes || []);

        const filteredHotels = allPackages.filter(
          pkg => pkg?.category?.name?.toLowerCase() === "hotels"
        );
        console.log("Hotel", filteredHotels);
        setHotelPackages(filteredHotels);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const closeNavbar = () => {
    setIsToggled(false);
  };

  const handleLogOut = () => {
    alert("You are Logging out...");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    setIsLoggedIn(false);
    setIsToggled(false);
    setTimeout(() => {
      navigate("/");
    }, 1500);
  };

  return (
    <div className="container-fluid p-0">
      <Seo
        title={`Ladakh Hotel Packages | ${SITE_NAME}`}
        description={`Find the best Ladakh hotel booking packages with ${SITE_NAME} - comfortable stays for every budget in Leh Ladakh.`}
        type="website"
        centralizedSeo={centralizedSeo}
      />








    <Nav/>






      {/* --- END CUSTOM NAVBAR --- */}

      <div className="container py-5 mt-5">
        <div className="row d-flex my-5">
          <h1
            className="col-md-4 fw-bold"
            style={{
              fontSize: "2rem",
              fontWeight: "700",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Explore Resorts
          </h1>
          <p className="col-md-8 text-center ">Ride through Ladakh’s summer bliss - blooming valleys, clear skies, and cultural wonders. A perfect blend of adventure, beauty, and serenity on every winding turn.</p>
        </div>

        <div className="row mt-3">
          {hotelPackages.map((hotel, index) => (
            <div key={index} className="col-md-3 p-2 mb-4">
              <div className="card h-100 border-0">
                <div style={{ position: "relative" }}>
                  <img
                    src={hotel.image?.[0] || "https://via.placeholder.com/300"}
                    className="card-img-top"
                    alt={hotel.name}
                    style={{ height: "200px", objectFit: "cover", borderRadius: "15px" }}
                  />
                  {/* <Link
                    to={`/DetailHotelPackage/${hotel.id}`}
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      fontSize: "15px",
                      color: "#fff",
                      textDecoration: "none"
                    }}
                  >
                    View Details
                  </Link> */}
                </div>
                <div className="card-body">
                  <Link
                    to={`/detail-hotel-package/${hotel.name?.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <h2 className="card-title" style={{ fontSize: '19px' }}>{hotel.name}</h2>
                    <p className="card-text text-muted">{hotel.location}</p>
                  </Link>
                  {/* <h5 className="card-title">{hotel.name}</h5>
                  <p className="card-text text-muted">{hotel.location}</p> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HotelPackage;
